import { Image, Menu, Collapse } from "antd";
import { useContext, useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

import MyLifeSaverLogo from "../../assets/images/mylifesaverLogo.png";
import Dash from "../../assets/images/side_nav/dashboard-icon.svg";
import PurchaseIcon from "../../assets/images/side_nav/purchase-credits-icon.svg";
import TqSurveysIcon from "../../assets/images/side_nav/tq-surveys-icon.svg";
import FollowUpIcon from "../../assets/images/side_nav/follow-tq-icon.svg";
import ReportIcon from "../../assets/images/side_nav/complated-report-icon.svg";
import CertificatesIcon from "../../assets/images/side_nav/certificates-icon.svg";
import PersonalInfoIcon from "../../assets/images/side_nav/personal-info-icon.svg";
import ChangePassIcon from "../../assets/images/side_nav/change-password-icon.svg";
import GuidesIcon from "../../assets/images/side_nav/guides-icon.svg";
import LogoutIcon from "../../assets/images/side_nav/logout-icon.svg";
import LogoutIcon02 from "../../assets/images/logout-icon.svg";

import { AuthContext } from "../../context/AuthContext";
import lang from "../../helper/langHelper";
import { useAppContext } from "../../context/AppContext";
import { Severty, ShowToast } from "../../helper/toast";
import moment, { isMoment } from "moment";
import DeleteModal from "../DeleteModal";

export const countryWithAreas = [
  "646b2e0f46865f1f65565346", //Palestine
];

export const menuItems = [
  {
    key: "Admin Management",
    label: `Admin Management`,
    icon: ChangePassIcon,
    path: "/",
  },
  {
    key: "Sub Admin Management",
    label: `Sub Admin Management`,
    icon: ChangePassIcon,
    path: "/sub-admin",
  },
  {
    key: "User Management",
    label: `User Management`,
    icon: ChangePassIcon,
    path: "/user-management",
  },
  {
    key: "Location Dashboard",
    label: "Location Dashboard",
    icon: ChangePassIcon,
    path: "/location-dashboard",
  },
  {
    key: "Data Export",
    label: "Data Export",
    icon: ChangePassIcon,
    path: "/data-export",
  },
  {
    key: "Notification Management",
    label: "Notification Management",
    icon: ChangePassIcon,
    path: "/notification-management",
  },
  {
    key: "Profile Settings",
    label: "Profile Settings",
    icon: PersonalInfoIcon,
    path: "/profile-settings",
  },
];

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const { userProfile, logout, setUserProfile } = useContext(AuthContext);
  const { country } = useAppContext();
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState(menuItems);
  const [menuMode, setMenuMode] = useState("vertical");
  const [currentDateTime, setCurrentDateTime] = useState(moment());
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const navigate = useNavigate();

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
  };
  
  const onClick = (e) => {
    console.log("click ", e);
  };

  const renderTitle = (item) => {
    return (
      <>
        <Image preview={false} src={item.icon} />
        <span className="label">{item.label}</span>
      </>
    );
  };

  useEffect(() => {
    setLoading(true);
    if (!userProfile) {
      setLoading(false);
      return;
    }
    const type = userProfile.type || userProfile.userType;
    let items = menuItems;
    if (type === "SuperAdmin") {
      items = menuItems;
    } else if (type === "Admin") {
      items = menuItems.filter((item) => item.key !== "Admin Management" && item.key !==  "Profile Settings");
    } else if (type === "SubAdmin") {
      items = menuItems.filter(
        (item) =>
          item.key !== "Admin Management" && item.key !== "Sub Admin Management" && item.key !== "Profile Settings"
      );
    } else {
      items = menuItems.filter(
        (item) =>
          item.key !== "Admin Management" && item.key !== "Sub Admin Management" && item.key !== "Profile Settings"
      );
    }
    setMenuLinks(items);
    setLoading(false);
  }, [userProfile, country]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode("inline");
      } else {
        setMenuMode("vertical");
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const updateDateTime = () => {
      setCurrentDateTime(moment());
    };

    const intervalId = setInterval(updateDateTime, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <>
        <div className="brand-logo">
          <img src={MyLifeSaverLogo} alt="My Life Saver" style={{ maxWidth: "100%", height: "auto", maxHeight: 48, objectFit: "contain" }} />
          {/* <p style={{ color: "white" }}>
              {currentDateTime.format("YYYY-MM-DD hh:mm a")}
            </p> */}
        </div>
        <Menu inlineCollapsed={false} mode="inline" className="sideNavMain">
          {menuLinks.map((item) => {
            if (item.children) {
              return (
                <>
                  <Menu.SubMenu
                    key={item.key}
                    title={
                      <>
                        <Image preview={false} src={item.icon} />

                        <span className="label">{item.label}</span>
                      </>
                    }
                  >
                    {item.children.map((child) => (
                      <Menu.Item key={child.key}>
                        <NavLink to={child.path}>{child.label}</NavLink>
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                </>
              );
            }

            return (
              <Menu.Item key={item.key}>
                <NavLink to={item.path}>{renderTitle(item)}</NavLink>
              </Menu.Item>
            );
          })}

          <Menu.Item
            onClick={showDeleteConfirm}
            // onClick={() => Navigate("/login")}
          >
            <NavLink to={"#"}>
              <>
                <Image preview={false} src={LogoutIcon} />
                <span className="label"> Logout </span>
              </>
            </NavLink>
          </Menu.Item>
        </Menu>
        {isLogoutModalVisible && (
          <DeleteModal
            icon={LogoutIcon02}
            title={"Logout"}
            subtitle={`Securely sign out of your account`}
            show={isLogoutModalVisible}
            hide={() => {
              setIsLogoutModalVisible(false);
            }}
            onOk={() => {
              try {
                logout();
                navigate("/login");
                setIsLogoutModalVisible(false); // Close the modal
              } catch (error) {
                console.error("Logout error:", error);
                ShowToast("Logout failed", Severty.ERROR);
              }
            }}
          />
        )}
      </>
    </>
  );
}

export default Sidenav;
